import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { trim } from 'lodash';
import Accordion from 'common-ui-components/dist/components/Molecules/Accordion';
import Input from 'common-ui-components/dist/components/Atoms/Input';
import find from 'lodash/find';
import './Promotional.scss';

const Promotional = ({
  header,
  collapseIcon,
  openIcon,
  addPromoCode,
  promos,
  labels,
  setErrorMessage,
}) => {
  const [promoValue, setPromoValue] = useState('');

  const handleOnChange = e => {
    setPromoValue(e);
  };

  const handleKeyPress = e => {
    e.stopPropagation();
  };

  const onSubmit = () => {
    const coupons = [];
    const value = (promoValue && trim(promoValue)) || '';
    coupons.push({
      code: value,
    });
    const data = { coupons };
    const obj = {
      body: data,
      remove: false,
    };
    if (promos.length > 4) {
      setErrorMessage(labels.maxPromoCodeError);
    } else if (find(promos, promo => promo.code.toLowerCase() === value.toLowerCase())) {
      setErrorMessage(labels.duplicatePromoError);
    } else if (value) {
      setErrorMessage('');
      setPromoValue('');
      addPromoCode(obj);
    }
  };

  const inputProps = {
    id: 'promoCode',
    name: 'promoCode',
    type: 'text',
    withSubmit: true,
    value: promoValue,
    onChange: handleOnChange,
    onSubmit,
    placeholder: labels.promotionalCodePlaceholder,
    onKeyPress: handleKeyPress,
    elementLocator: 'input-order-summary-promo-code',
  };

  return (
    <Accordion
      heading={header}
      collapseIcon={collapseIcon}
      openIcon={openIcon}
      elementLocator={header}
    >
      <div className="promo-code" data-locator="order-summary-promo-code">
        <Input {...inputProps} />
      </div>
    </Accordion>
  );
};

Promotional.propTypes = {
  header: PropTypes.string,
  collapseIcon: PropTypes.string,
  openIcon: PropTypes.string,
  addPromoCode: PropTypes.func,
  promos: PropTypes.arrayOf(PropTypes.string),
  labels: PropTypes.objectOf(PropTypes.string),
  setErrorMessage: PropTypes.func,
};

Promotional.defaultProps = {
  header: '',
  collapseIcon: '',
  openIcon: '',
  addPromoCode: () => {
    /* default addPromoCode handler */
  },
  promos: [],
  labels: {},
  setErrorMessage: () => {
    /* default setErrorMessage handler */
  },
};

export default Promotional;
